<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-08 14:36:07
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-18 17:55:21
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\logisticsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="pl-16 pr-16 font-h6-regular yx-color-text-primary" style="width: 158px">
		<div class="flex-row-align-center">
			<div :class="deliveryIcon" class="mr-4"></div>
			<el-popover placement="bottom-start" width="200" trigger="hover" :disabled="!ispopover" :content="popoverContent">
				<span slot="reference" :class="[ispopover ? 'cursor-pointer' : '']">
					{{ deliveryStatusDesc }}
					<i class="el-icon-arrow-right mt-2" v-if="ispopover"></i>
				</span>
			</el-popover>
		</div>
		<div class="flex-row-align-center font-h6-regular yx-color-text-primary mt-4" v-if="delivery_info">
			<el-tooltip placement="top" v-ak-tooltip-auto-show :content="delivery_info">
				<div class="line-ellipsis" style="width: 100%">{{ delivery_info }}</div>
			</el-tooltip>
		</div>
		<div class="flex-row-align-center font-h6-regular yx-color-text-primary mt-4" v-if="row.shipping_company">
			<span class="flex-shrink">{{ row.shipping_company }}</span>
			<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.shipping_sn">
				<span style="width: 100%" class="line-ellipsis ml-4">{{ row.shipping_sn | formatEmpty }}</span>
			</el-tooltip>
		</div>
		<div class="mt-2" v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])">
			<darkTag
				:status="row.order_cooperate_status"
				:desc="row.order_cooperate_status_desc"
				:reason="syncReason"
				v-if="injectCooperationStatus() && vuex_isshopurl"
			/>
		</div>
		<div class="mt-2">
			<plainTag type="primary" v-if="showMore(row)">多样品订单</plainTag>
		</div>
	</div>
</template>
<script>
import { sampleStutas } from '@/utils/dataMap';
import plainTag from '@/components/ui/plainTag';
import darkTag from './darkTag.vue';
import { mapState } from 'vuex';
export default {
	components: {
		plainTag,
		darkTag,
	},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	inject: {
		injectCooperationStatus: {
			default: () => false,
		},
	},
	computed: {
		...mapState(['vuex_isshopurl']),
		ispopover({ row }) {
			return +row.order_other_status === +sampleStutas.rejectShipment || +row.order_other_status === +sampleStutas.noPass;
		},
		popoverContent({ row }) {
			return +row.order_other_status === +sampleStutas.rejectShipment
				? row.refuse_delivery_content
				: +row.order_other_status === +sampleStutas.noPass
				? row.refuse_reason
				: '';
		},
		deliveryStatusDesc({ row }) {
			return +row.order_other_status === +sampleStutas.Audit ||
				+row.order_other_status === +sampleStutas.noPass ||
				+row.order_other_status === +sampleStutas.rejectShipment
				? row.order_other_status_desc
				: row.delivery_status_desc;
		},
		deliveryIcon({ row }) {
			let obj = {};

			//拒绝发货
			if (row.is_refuse_delivery === '1') {
				obj = {
					[sampleStutas.rejectShipment]: 'i-cooperation-logistics-5', //拒绝发货
				};
				return obj[row.order_other_status];

				//待审核
			} else if (+row.order_other_status === +sampleStutas.Audit || +row.order_other_status === +sampleStutas.noPass) {
				obj = {
					[sampleStutas.Audit]: 'i-cooperation-logistics-6', //待审核
					[sampleStutas.noPass]: 'i-cooperation-logistics-5', //审核不通过
				};
				return obj[row.order_other_status];
			} else {
				obj = {
					[sampleStutas.tobeShipped]: 'i-cooperation-logistics-1', //待发货
					[sampleStutas.Shipped]: 'i-cooperation-logistics-2', //已发货
					[sampleStutas.transit]: 'i-cooperation-logistics-3', //运输中
					[sampleStutas.Arrived]: 'i-cooperation-logistics-4', //已到货
				};
				return obj[row.delivery_status];
			}
		},
		delivery_info() {
			const { row } = this;
			return row.delivery_info && row.delivery_info[0] ? row.delivery_info[0].context : '';
		},
		showMore() {
			return ({ order_num }) => Number(order_num) > 1;
		},
		syncReason({ row }) {
			return +row.order_cooperate_status === 0 ? '请前往[合作店铺-店铺列表]发送样品协作，绑定后即可协作样品订单。' : row.cooperate_failure_reason;
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
.more-parcel {
	background-color: #e9f1ff;
	padding: 0 4px;
	text-align: center;
}
</style>
